import { render, staticRenderFns } from "./ModalCompanyTranslation.vue?vue&type=template&id=42544343"
import script from "./ModalCompanyTranslation.vue?vue&type=script&lang=js"
export * from "./ModalCompanyTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports